module.exports = new __parcel__URL__("game-watch-gallery-2.c0a8badf.jpg").toString();